// registrationMachine.js
export const pathways = {
    'state-school': {
        label: 'UK State School (FREE)',
        steps: ['schoolTypeAndSearch', 'confirmSchool', 'invalidEmail', 'offerAdminStatus',],
        requires: {
            schoolSearch: true,
            addressDetails: false,
            paidSubscription: false,
            domainValidation: true,
            unableToCompleteOnline: false,
        },
    },
    'independent-school': {
        label: 'UK Independent School',
        // steps: ['schoolTypeAndSearch', 'confirmSchool', 'activeSubscriptionFound', 'noActiveSubscriptionOther', 'selectSubscriptionPackageOther', 'confirmSubscriptionOther', 'offerAdminStatus', "paymentConfirmation",],
        steps: ['schoolTypeAndSearch', 'contactSupport'],
        requires: {
            schoolSearch: false,
            addressDetails: false,
            paidSubscription: false,
            domainValidation: false,
            unableToCompleteOnline: true,
        },
    },
    'individual': {
        label: 'Homeschool',
        // steps: ['schoolTypeAndSearch', 'confirmDetails', 'noActiveSubscriptionIndividual', 'selectSubscriptionPackageIndividual', 'confirmSubscriptionIndividual',"paymentConfirmation"],
        steps: ['schoolTypeAndSearch', 'contactSupport'],
        requires: {
            schoolSearch: false,
            addressDetails: false,
            paidSubscription: false,
            domainValidation: false,
            unableToCompleteOnline: true,
        },
    },
    'international': {
        label: 'International School',
        // steps: ['schoolTypeAndSearch', 'confirmSchool', 'activeSubscriptionFound', 'noActiveSubscriptionOther', 'selectSubscriptionPackageOther', 'confirmSubscriptionOther', 'offerAdminStatus', "paymentConfirmation",],
        steps: ['schoolTypeAndSearch', 'contactSupport'],
        requires: {
            schoolSearch: false,
            addressDetails: false,
            paidSubscription: false,
            domainValidation: false,
            unableToCompleteOnline: true,
        },
    },
    'consortium': {
        label: 'Group of Schools (UK/Ireland)',
        steps: ['schoolTypeAndSearch', 'contactSupport'],
        requires: {
            schoolSearch: false,
            addressDetails: false,
            paidSubscription: false,
            domainValidation: false,
            unableToCompleteOnline: true,
        },

    }
};
const initialSteps = ['lookupAccount', 'createAccount'];


export const registrationMachine = {
    id: 'registration',
    state: 'lookupAccount',
    context: {
        pathway: null,
        pathwaySteps: [],
        selectedSchool: null,
        email: null,
        constituentId: null,
        password: null,
        sessionData: null,
    },
    transition(current, type, payload = {}) {
        if (type === 'START') {
            const hasConstituent = payload.constituentId;
            return {nextState: hasConstituent ? 'schoolTypeAndSearch' : 'lookupAccount'};
        }

        if (type === 'SIGN_UP_VIA_TOKEN') {
            return {nextState: "createAccount"}
        }

        if (type === 'PAYMENT_PROCESS') {
            const hasConstituent = payload.constituentId;
            return {nextState: hasConstituent ? 'paymentProcessing' : 'somethingWentWrongWithPayment'};
        }

        if (type === 'PAYMENT_COMPLETE') {
            return {nextState: 'done'};
        }

        if (type === 'PATHWAY_CHOSEN') {
            const pathway = pathways[payload.pathway];
            const steps = pathway.steps;

            // Find the index of 'choosePathway' and move to the next step
            const currentStepIndex = steps.indexOf('choosePathway');
            const nextStep = steps[currentStepIndex + 1] || 'done'; // fallback if end

            return {
                nextState: nextStep,
                updates: {
                    pathway: payload.pathway,
                    pathwaySteps: steps,
                },
            };
        }

        if (type === "NEXT_STEP") {
            const fullFlow = [
                ...initialSteps,
                ...(payload.pathwaySteps || [])
            ];
            const steps = payload.pathwaySteps || this.context.pathwaySteps;
            const currentIndex = fullFlow.indexOf(current);
            const nextState = payload.forceStep || fullFlow[currentIndex + 1] || 'done';
            return {nextState};
        }

        if (type === 'BACK') {
            const fullFlow = [
                ...initialSteps,
                ...(payload.pathwaySteps || [])
            ];
            const currentIndex = fullFlow.indexOf(current);
            const prevState = payload.forceStep || fullFlow[currentIndex - 1] || fullFlow[0];
            return {nextState: prevState};
        }

        return {nextState: current};
    },
};
